<template>
  <div>
    <component :is="activeComponent" v-bind="passProps"></component>
  </div>
</template>

<script>
import DefaultEventRenderer from '@/components/UIComponents/EventDataRenderers/DefaultEventRenderer.vue';
import DisplayStatusChangeRenderer from '@/components/UIComponents/EventDataRenderers/DisplayStatusChangeRenderer.vue';
import CourseStartedWithoutVehicleRenderer from '@/components/UIComponents/EventDataRenderers/CourseStartedWithoutVehicleRenderer.vue';
import VehicleAssignmentFailedRenderer from '@/components/UIComponents/EventDataRenderers/VehicleAssignmentFailedRenderer.vue';
import VehicleTimetableDeviationRenderer from '@/components/UIComponents/EventDataRenderers/VehicleTimetableDeviationRenderer.vue';
import TtsTooManyButtonPressesRenderer from '@/components/UIComponents/EventDataRenderers/TtsTooManyButtonPressesRenderer.vue'
import NewVirtualStopRenderer from '@/components/UIComponents/EventDataRenderers/NewVirtualStopRenderer.vue'
export default {
  name: 'EventDataRenderer',
  components: { DefaultEventRenderer, VehicleTimetableDeviationRenderer, VehicleAssignmentFailedRenderer, DisplayStatusChangeRenderer, CourseStartedWithoutVehicleRenderer, TtsTooManyButtonPressesRenderer, NewVirtualStopRenderer},
  props: {
    id: {
      type: Number,
      required: true,
    },
    eventType: {
      type: String,
      required: true,
    },
    eventData: {
      type: String,
      required: true,
    }
  },
  computed: {
    activeComponent() {
      if(!this.eventType) return 'default-event-renderer';
      let lowerCaseType = this.eventType.toLowerCase();
      let hyphenatedType = lowerCaseType.replace(/_/g, '-');
      return `${hyphenatedType}-renderer`;
    },
    passProps() {
      return { eventData: this.eventData, eventType: this.eventType }
    }
  }
};
</script>